export interface ICiudad {
  id?: number;
  nombre?: string;
}

export class Ciudad implements ICiudad {
  constructor() {
  }
}
